import { render, staticRenderFns } from "./DistributorAssociation.vue?vue&type=template&id=1732e71a&"
import script from "./DistributorAssociation.vue?vue&type=script&lang=js&"
export * from "./DistributorAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports